import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Jobs.css';

const IconRocket   = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 00-2.91-.09z"/><path d="M12 15l-3-3a22 22 0 012-3.95A12.88 12.88 0 0122 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 01-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></svg>;
const IconBook     = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/></svg>;
const IconGlobe    = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>;
const IconUsers    = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>;

const jobs = [
  {
    id: 1,
    title: 'Cybersecurity Analyst',
    department: 'Enterprise Security',
    type: 'Full-time',
    location: 'Remote / Hybrid',
    level: 'Senior',
    openings: 2,
    posted: '2 weeks ago',
    desc: 'Join our Enterprise Security team as a Cybersecurity Analyst. You will play a critical role in protecting our clients\' digital environments through proactive monitoring, threat analysis, and incident response.',
    requirements: [
      '5+ years in technical cybersecurity engineering or analyst roles',
      'Expertise in datacenter virtualization and network security',
      'Microsoft Active Directory, Windows hardening, and XDR stack',
      'Security monitoring: SIEM, Centralized Logging, UEBA, SOC processes',
      'Offensive security: penetration testing and vulnerability assessments',
      'Programming: Python, PowerShell, .Net, Java, DevSecOps, KQL',
      'Database security, CASB, and DLP expertise',
      'Cloud security across Azure, AWS, GCP, OCI, Office 365',
      'Knowledge of ISO 27001/27017/27018/27032, NIST, and MITRE ATT&CK',
    ],
    preferred: [
      'CISSP, SANS GIAC, or CISM certifications',
      'Experience in financial or healthcare sector environments',
      'Familiarity with threat hunting methodologies',
    ],
    tags: ['SIEM', 'Penetration Testing', 'Cloud Security', 'Python', 'NIST'],
  },
];

export default function Jobs() {
  const [expanded, setExpanded] = useState(null);

  return (
    <div className="jobs-page">
      {/* Hero */}
      <section className="page-hero">
        <div className="container page-hero-content">
          <span className="section-label section-label--blue">Career Opportunities</span>
          <h1>Join the <span style={{ color: '#d5772d' }}>ThirdEye Team</span></h1>
          <p>Be part of a team that is building the next generation of cybersecurity resilience. We are looking for passionate professionals who want to make a real difference.</p>
        </div>
      </section>

      {/* Why Work With Us */}
      <section className="jobs-perks">
        <div className="container">
          <div className="section-header centered">
            <span className="section-label">Why Join Us</span>
            <h2 className="section-title">Built for <span>Security Professionals</span></h2>
          </div>
          <div className="perks-grid">
            {[
              { icon: <IconRocket />, title: 'Impactful Work', desc: 'Work on real security challenges for clients across diverse industries. Every day brings new problems to solve.' },
              { icon: <IconBook />,   title: 'Continuous Learning', desc: 'Full support for professional development, certifications, and attending industry conferences.' },
              { icon: <IconGlobe />,  title: 'Remote Flexibility', desc: 'Flexible remote and hybrid work arrangements that respect your work-life balance.' },
              { icon: <IconUsers />,  title: 'Expert Network', desc: 'Collaborate with a team of top-tier security professionals and build your professional network.' },
            ].map((perk, i) => (
              <div className="perk-card" key={i}>
                <div className="perk-icon">{perk.icon}</div>
                <h3>{perk.title}</h3>
                <p>{perk.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Job Listings */}
      <section className="jobs-listings">
        <div className="container">
          <div className="section-header">
            <span className="section-label">Open Positions</span>
            <h2 className="section-title">Current <span>Openings</span></h2>
            <p className="section-desc">{jobs.length} position{jobs.length !== 1 ? 's' : ''} available</p>
          </div>

          <div className="jobs-list">
            {jobs.map(job => (
              <div className="job-card" key={job.id}>
                <div className="job-card-header" onClick={() => setExpanded(expanded === job.id ? null : job.id)}>
                  <div className="job-main-info">
                    <div className="job-title-row">
                      <h3 className="job-title">{job.title}</h3>
                      <span className="job-openings">{job.openings} Opening{job.openings > 1 ? 's' : ''}</span>
                    </div>
                    <div className="job-meta">
                      <span className="job-meta-item">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/></svg>
                        {job.department}
                      </span>
                      <span className="job-meta-item">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
                        {job.location}
                      </span>
                      <span className="job-meta-item">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                        {job.posted}
                      </span>
                    </div>
                    <div className="job-tags">
                      <span className={`job-badge job-badge--${job.type === 'Full-time' ? 'blue' : 'cyan'}`}>{job.type}</span>
                      <span className="job-badge job-badge--teal">{job.level}</span>
                      {job.tags.map(t => <span key={t} className="job-tag">{t}</span>)}
                    </div>
                  </div>
                  <button className={`job-expand-btn ${expanded === job.id ? 'open' : ''}`}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>
                  </button>
                </div>

                {expanded === job.id && (
                  <div className="job-details">
                    <p className="job-desc">{job.desc}</p>

                    <div className="job-reqs-grid">
                      <div>
                        <h4 className="job-req-title">Requirements</h4>
                        <ul className="job-req-list">
                          {job.requirements.map((r, i) => (
                            <li key={i}>
                              <span className="req-check">
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                              </span>
                              {r}
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div>
                        <h4 className="job-req-title">Preferred Qualifications</h4>
                        <ul className="job-req-list preferred">
                          {job.preferred.map((p, i) => (
                            <li key={i}>
                              <span className="req-star">★</span>
                              {p}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    <div className="job-apply">
                      <Link to="/contact" className="btn-primary">
                        Apply Now
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
                      </Link>
                      <p className="job-apply-note">Send your resume and cover letter via our contact page. Reference the job title in your message.</p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="no-match-box">
            <h3>Do Not See a Perfect Fit?</h3>
            <p>We are always looking for exceptional cybersecurity talent. Send us your resume and we will keep you in mind for future opportunities.</p>
            <Link to="/contact" className="btn-primary" style={{ display: 'inline-flex', marginTop: '20px' }}>
              Send Your Resume
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
